import { post } from './request'

export function homeStats() {
  return post('/api/Home/Stats', {})
}
